export function getMemberGroupIds(member, groups = []) {
  if (!member) return [];

  const ids = new Set();
  if (member.group_id) ids.add(member.group_id);

  for (const group of groups) {
    if (group?.id && Array.isArray(group.member_ids) && group.member_ids.includes(member.id)) {
      ids.add(group.id);
    }
  }

  return [...ids];
}

export function canViewEventByAudience(event, { member, memberGroupIds = [] } = {}) {
  const audiences = Array.isArray(event?.audiences) ? event.audiences : [];

  // No audience configured = public event.
  if (audiences.length === 0) return true;

  // "Todos" is always public, including anonymous users.
  if (audiences.some((aud) => aud?.type === 'Todos')) return true;

  // Private only when there is at least one group audience.
  const groupAudienceIds = audiences
    .filter((aud) => aud?.type === 'Grupo' && !!aud?.id)
    .map((aud) => aud.id);

  if (groupAudienceIds.length === 0) return true;
  if (!member) return false;

  return groupAudienceIds.some((groupId) => memberGroupIds.includes(groupId));
}
